<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ffffff"
    >
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <rect x="15" y="2" rx="0" ry="0" width="339" height="20" />
        <rect x="16" y="194" rx="0" ry="0" width="339" height="15" />
        <rect x="17" y="57" rx="0" ry="0" width="37" height="14" />
        <rect x="15" y="27" rx="0" ry="0" width="176" height="20" />
        <rect x="64" y="58" rx="0" ry="0" width="54" height="14" />
        <rect x="15" y="78" rx="0" ry="0" width="339" height="103" />
        <rect x="15" y="215" rx="0" ry="0" width="339" height="15" />
        <rect x="15" y="235" rx="0" ry="0" width="339" height="15" />
        <rect x="15" y="256" rx="0" ry="0" width="339" height="15" />
        <rect x="17" y="277" rx="0" ry="0" width="339" height="15" />
        <rect x="16" y="298" rx="0" ry="0" width="339" height="15" />
        <rect x="16" y="318" rx="0" ry="0" width="339" height="15" />
        <rect x="16" y="339" rx="0" ry="0" width="197" height="15" />
        <rect x="18" y="378" rx="0" ry="0" width="339" height="15" />
        <rect x="17" y="399" rx="0" ry="0" width="339" height="15" />
        <rect x="17" y="419" rx="0" ry="0" width="339" height="15" />
        <rect x="17" y="440" rx="0" ry="0" width="339" height="15" />
        <rect x="19" y="461" rx="0" ry="0" width="339" height="15" />
        <rect x="18" y="482" rx="0" ry="0" width="339" height="15" />
        <rect x="19" y="504" rx="0" ry="0" width="197" height="15" />
        <rect x="22" y="542" rx="0" ry="0" width="339" height="15" />
        <rect x="21" y="563" rx="0" ry="0" width="339" height="15" />
        <rect x="21" y="583" rx="0" ry="0" width="339" height="15" />
        <rect x="21" y="604" rx="0" ry="0" width="339" height="15" />
        <rect x="21" y="631" rx="0" ry="0" width="197" height="15" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/articleDetailSkeleton.vue